const getRandomNumber = (x, y) =>
  Math.trunc(x + (y - x + 1) * (crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32)) || 0;

export default getRandomNumber;
